import { subscribeToNewsletter as subscribeToNewsletterApi } from '../util/api';

/**
 * The footer's newsletter signup: whether it is on its way, and how it went.
 */

// ================ Action types ================ //

export const SUBSCRIBE_REQUEST = 'app/newsletter/SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'app/newsletter/SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_ERROR = 'app/newsletter/SUBSCRIBE_ERROR';
export const CLEAR_SUBSCRIBE_OUTCOME = 'app/newsletter/CLEAR_SUBSCRIBE_OUTCOME';

// ================ Reducer ================ //

const initialState = {
  subscribeInProgress: false,
  // 'subscribed' or 'alreadySubscribed' once it went through
  subscribeResult: null,
  // { invalidEmail: true } when the server turned the email down (400), else { failed: true };
  // the footer words both from en.json
  subscribeError: null,
};

export default function newsletterReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SUBSCRIBE_REQUEST:
      return { ...state, subscribeInProgress: true, subscribeResult: null, subscribeError: null };
    case SUBSCRIBE_SUCCESS:
      return { ...state, subscribeInProgress: false, subscribeResult: payload };
    case SUBSCRIBE_ERROR:
      return { ...state, subscribeInProgress: false, subscribeError: payload };
    case CLEAR_SUBSCRIBE_OUTCOME:
      return { ...state, subscribeResult: null, subscribeError: null };
    default:
      return state;
  }
}

/** The email is being edited: the last signup's message goes. */
export const clearSubscribeOutcome = () => ({ type: CLEAR_SUBSCRIBE_OUTCOME });

// ================ Thunks ================ //

/** Signs the email up for the newsletter. Resolves true when it went through. */
export const subscribeToNewsletter = email => dispatch => {
  dispatch({ type: SUBSCRIBE_REQUEST });
  return subscribeToNewsletterApi(email)
    .then(response => {
      const data = response?.data || {};
      if (data.success || data.alreadySubscribed) {
        dispatch({
          type: SUBSCRIBE_SUCCESS,
          payload: data.success ? 'subscribed' : 'alreadySubscribed',
        });
        return true;
      }
      dispatch({ type: SUBSCRIBE_ERROR, payload: { failed: true } });
      return false;
    })
    .catch(e => {
      const payload = e?.status === 400 ? { invalidEmail: true } : { failed: true };
      dispatch({ type: SUBSCRIBE_ERROR, payload });
      return false;
    });
};
